<script setup lang="ts">
import LazyImage from '~/components/design-system/lazy-image.vue';

const { logoSets } = useBranding();
</script>

<template>
  <div class="h-screen relative flex flex-center">
    <div
      class="maintenance-page flex flex-col flex-center text-light-50 p-3 text-center space-y-8 absolute z-[10]"
    >
      <LazyImage class="w-[180px]" :src="logoSets.dark" alt="Jackpotcity" />
      <img
        src="/images/maintenance.png"
        alt="Jackpot City Maintenance"
        class="w-[400px]"
      />

      <div>
        <h1>Suspended</h1>
        <p class="font-bold">
          Please be advised that we have decided to suspend our operations. We
          appreciate your understanding and patience during this time.
        </p>
        <p>We will provide you with an update as soon as possible.</p>
      </div>
    </div>
    <div class="w-full h-full absolute jpc-radial-glow" />
  </div>
</template>

<style scoped lang="scss"></style>
